import { staticSelector } from 'ducks/static'
import useMediaQuery from 'hooks/useMediaQuery'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import {
  Bottom,
  Container,
  Options,
  SocialIcon,
  SocialLink,
  Socials,
  Column,
  TitleCol,
  Item,
  LinkExternal,
  SubContainer,
  Icons,
  Line,
  Content,
  SocialContainer,
  SocialIcons,
  ColumnsContainer,
  CopyrightContainer,
  Copyright,
  SubContainerResponsive,
} from './styled'

export const FooterHome: FC = () => {
  const state = useSelector(staticSelector)
  const matches = useMediaQuery('(min-width: 960px)')

  return (
    <Container>
      <Content>
        <Line />
        {matches ? (
          state.content.footer && (
            <Options>
              <Socials>
                {state.content.footer.social && state.content.footer.social.length ? (
                  <Icons>
                    {state.content.footer.social?.map((item: any) => {
                      return (
                        <SocialLink key={item.icon.url} href={item.url} target="blank">
                          <SocialIcon src={item.icon.url} />
                        </SocialLink>
                      )
                    })}
                  </Icons>
                ) : null}
                <Bottom>{state.content.footer && state.content.footer.copyright}</Bottom>
              </Socials>
              {state.content.footer.column && state.content.footer.column.length
                ? state.content.footer.column?.map((item: any) => {
                    return (
                      <SubContainer key={item.title}>
                        {item.title ? <TitleCol>{item.title}</TitleCol> : null}
                        <Column>
                          {item.link.map((link: any) => {
                            return (
                              <LinkExternal key={link.label} href={link.path}>
                                <Item>{link.label}</Item>
                              </LinkExternal>
                            )
                          })}
                        </Column>
                      </SubContainer>
                    )
                  })
                : null}
            </Options>
          )
        ) : (
          <>
            <SocialContainer>
              <SocialIcons>
                {state.content.footer.social && state.content.footer.social.length
                  ? state.content.footer.social?.map((item: any) => {
                      return (
                        <SocialLink key={item.icon.url} href={item.url} target="blank">
                          <SocialIcon src={item.icon.url} />
                        </SocialLink>
                      )
                    })
                  : null}
              </SocialIcons>
            </SocialContainer>
            <ColumnsContainer>
              {state.content.footer.column && state.content.footer.column.length
                ? state.content.footer.column?.map((item: any) => {
                    return (
                      <SubContainerResponsive key={item.title}>
                        {item.title ? <TitleCol>{item.title}</TitleCol> : null}
                        <Column>
                          {item.link.map((link: any) => {
                            return (
                              <LinkExternal key={link.label} href={link.path}>
                                <Item>{link.label}</Item>
                              </LinkExternal>
                            )
                          })}
                        </Column>
                      </SubContainerResponsive>
                    )
                  })
                : null}
            </ColumnsContainer>
            <CopyrightContainer>
              {state.content.footer.copyright ? <Copyright>{state.content.footer.copyright}</Copyright> : null}
            </CopyrightContainer>
          </>
        )}
      </Content>
    </Container>
  )
}
